module.exports = __webpack_public_path__ + "images/emoji/heavy_check_mark.05ba0dfd1bb9be5b7ea7.png";